export const localPaths = {
    login: 'login',
    signup: 'signup',
    emailSignUp: 'email-signup',
    resetPassword: 'reset-password',
    withdraw: 'withdraw',
    accountConfirmed: 'account-confirmed/:signupBy',
};